module.exports = __webpack_public_path__ + "img/4-1.d793c072.svg";